import React from 'react'
import { Header } from 'components/Header'
import { Button, Flex } from '@workwhile/ui'
import { QueryStatus } from 'components/QueryStatus'
import { useUserPermissionsContextValue } from '../context/UserPermissionsProvider'
import { useUserPermissionsWorkflowsContextValue } from '../context/UserPermissionsWorkflowsProvider'

export const UserPermissionsHeader = () => {
  const { state, actions } = useUserPermissionsContextValue()
  const { createUserPermissionsFlow, authorizeAdminFlow } =
    useUserPermissionsWorkflowsContextValue()

  return (
    <Header
      title="User Permissions"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
          <Button
            variant="secondary"
            kind="medium"
            onClick={authorizeAdminFlow.open}
          >
            Set up WorkWhile admin
          </Button>
          <Button
            variant="primary"
            kind="medium"
            onClick={createUserPermissionsFlow.open}
          >
            Grant permissions
          </Button>
        </Flex>
      }
    />
  )
}
